import React from 'react'
import SidebarTab from './ui/SidebarTab'

const Sidebar = () => {
  const links = [
    {
      label:'overview',
      path:'/'
    },
    {
      label:'missions',
      path:'/missions'
    },
    {
      label:'courses',
      path:'/courses'
    },
    {
      label:'challenges',
      path:'/challenges'
    },
    {
      label:'submissions',
      path:'/submissions'
    },
  ]
  return (
    <div className='w-full border border-blue-500 bg-slate-50 h-screen p-4 flex flex-col gap-2'>
     {
      links.map((link,ind) => <SidebarTab key={ind} label={link.label} path={link.path} />)
     }
    </div>
  )
}

export default Sidebar